
  document.addEventListener("DOMContentLoaded", function () {
    const filterButtons = document.querySelectorAll(".button.is-filter");
    const items = document.querySelectorAll(".cocktail-collection_item");

    // Use lowercase tags to match your HTML
    const filterGroups = {
      vodka: ["mango", "original"],
      difficulty: ["simple", "intermediate", "advanced"],
    };

    const activeFilters = {
      vodka: [],
      difficulty: [],
    };

    function getGroup(filter) {
      return Object.keys(filterGroups).find(group =>
        filterGroups[group].includes(filter)
      );
    }

    function updateFilters() {
      items.forEach(item => {
        const tags = item.dataset.tags?.toLowerCase().split(" ") || [];

        const matches = Object.keys(filterGroups).every(group => {
          const active = activeFilters[group];
          return active.length === 0 || active.some(f => tags.includes(f));
        });

        item.style.display = matches ? "" : "none";
      });
    }

    filterButtons.forEach(button => {
      const filter = button.dataset.filter?.toLowerCase();
      const group = getGroup(filter);
      if (!group) return;

      button.addEventListener("click", function (e) {
        e.preventDefault();
        const isActive = button.classList.toggle("is-active");

        if (isActive) {
          if (!activeFilters[group].includes(filter)) {
            activeFilters[group].push(filter);
          }
        } else {
          activeFilters[group] = activeFilters[group].filter(f => f !== filter);
        }

        updateFilters();
      });
    });
  });

